import './app.css';

import '@babel/polyfill';

import Swiper from '../node_modules/swiper/dist/js/swiper';
// import Swiper from 'swiper';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');

const body = document.body;

const setLoading = b => {

    body.dataset.loading = b ? '1' : '';
}

const setLoaded = b => {

    body.dataset.loaded = b ? '1' : '';
}

const setStarted = b => {

    body.dataset.started = b ? '1' : '';
}

const setShowUI = b => {

    body.dataset.showUi = b ? '1' : '';
}


/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */

import analyticsEvent from './js/analytics-event';

/* track events from html attributes */
const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

if (trackingElements.length > 0) {
    trackingElements.forEach(trackingElem => {
        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        });
    });
}


setLoading(true);
analyticsEvent('Page', 'load', 'Load');


/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Montserrat:n3,n4'],
        urls: ['./css/fonts.css']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
// window.$ = window.jQuery = require('jquery');


import 'latest-createjs';
const createjs = window.createjs;

const menuD = require('./js/menu');
const menuM = require('./js/menu-mobile');
const menuF = require('./js/footer');
const week = require('./js/week');
require('./js/news');

import './js/video-modal';

// const VirtualScroll = require('./js/virtualScroll/VirtualScroll');
const EffectMasking = require('./js/swiperEffects/MaskingEffect');
const CanvasMaskAnimationControlEffect = require('./js/swiperEffects/CanvasMaskAnimationControlEffect');
// const createCompoundEffect = require('./js/swiperEffects/CreateCompoundEffect');

// const CompoundEffect = createCompoundEffect('compoundTest', [EffectMasking, CanvasMaskAnimationControlEffect], false);

Swiper.use([EffectMasking, CanvasMaskAnimationControlEffect]);
const SizesUtils = require('./js/utils/SizesUtils');

let /* vs, */txSw, bgSw, pgSw, imSw;
const coverContainer = document.querySelector('.header-container');
coverContainer.deltaY = 0;
// const sections = [...document.querySelector('.content-viewport__section')];
const sectionWeek = document.querySelector('.content-viewport__section--week');
const sectionNews = document.querySelector('.content-viewport__section--news');
const scrlNextTrgrEl = document.querySelector('.scrollNextTrigger');
const footerEl = document.querySelector('.footer');
let curSection = 0;
let prevIndex = -1;
let transitionTO;
body.dataset.section = curSection;

function initSW() {


     bgSw = new Swiper('.gallery-menu__back', {
        speed: 750,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        followFinger: true,
        effect: 'masking',
        maskingEffect: {
            targetEl: '.masking-target'
        },
        // slideClass: 'slide',
        // wrapperClass: 'scene__container',
        touchEventsTarget: 'wrapper'
     });

     pgSw = new Swiper('.gallery-menu__pagination', {
        speed: 700,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        followFinger: true,
        // slideClass: 'slide',
        // wrapperClass: 'scene__container',
        touchEventsTarget: 'wrapper',
         pagination: {
             el: '.swiper-pagination',
             clickable: true,
             renderBullet: function (index, className) {
                 return `<span class="${className}">${(index + 1)}</span>`;
             }
         }
     });

     imSw = new Swiper('.gallery-menu__images', {
        speed: 750,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        followFinger: true,
         effect: 'CanvasMaskAnimationControl',
        // slideClass: 'slide',
        // wrapperClass: 'scene__container',
        touchEventsTarget: 'wrapper'
     });
     txSw = new Swiper('.gallery-menu__texts', {
        speed: 700,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        preventIntercationOnTransition: true,
        followFinger: true,
        effect: 'slide',
        maskingEffect: {
            targetEl: '.masking-target'
        },
        // slideClass: 'slide',
        // wrapperClass: 'scene__container',
        touchEventsTarget: 'wrapper',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        keyboard: {
            enabled: true
        }/* ,
         mousewheel: {
            enabled: true
        }*/
     });

     pgSw.controller.control = txSw;
     txSw.controller.control = [bgSw, imSw, pgSw];
    pgSw.slideTo(curSection);

    switchOnWinScroll(txSw);
    switchOnWinScrollStateUpdate();

    transitionTO = setTimeout(() => {
        if (transitionTO) {
            clearTimeout(transitionTO);
            transitionTO = void 0;
        }
        setShowUI(true);
    }, 1000);

    txSw.on('slideChange', () => {
         // console.log(txSw.previousIndex, txSw.activeIndex, txSw.realIndex);
         // vs.gotoCover(txSw.realIndex);

        analyticsEvent('Slider', 'change', 'Index: ' + txSw.activeIndex);

        if (curSection === txSw.realIndex) return;
        if (transitionTO) {clearTimeout(transitionTO); transitionTO = void 0;}
        resetPrevSlide(prevIndex);

        const rect = coverContainer.getBoundingClientRect();
        // console.log(rect, SizesUtils.winOffsetHeight());


        switch (curSection) {
            case 0:

                break;
            case 1:
                sectionWeek.classList.remove('active');
                break;
            case 2:

                break;
            case 3:
                sectionNews.classList.remove('active');
                break;
        }





        prevIndex = curSection;
        curSection = txSw.realIndex;
        updateBody();
        updateMenu();

        setShowUI(false);

        if (rect.bottom > 1) {


            if (curSection === 3) {
                footerEl.classList.remove('inactive');
                footerEl.classList.add('active');
            } else {
                footerEl.classList.remove('active');
            }

            prepareNewSlide(curSection);

            transitionTO = setTimeout(() => {
                if (transitionTO) {clearTimeout(transitionTO); transitionTO = void 0;}
                window.dispatchEvent(new Event('refresh'));

                setNewSlide(prevIndex, curSection);

                coverContainer.deltaY = 0;
                coverContainer.style.transform = 'translate3d(0, 0, 0)';
                window.scrollTo(0, 0);
            }, 100);

        } else {

            // Slide to at once:
            txSw.slideTo(curSection, 0);

            // Hide at once:
            coverContainer.style.transitionDuration = '0s';
            coverContainer.style.opacity = '0';

            // Move bottom at once:
            coverContainer.deltaY -= rect.top;
            coverContainer.style.transform = `translate3d(0, ${coverContainer.deltaY}px, 0)`;

            transitionTO = setTimeout(() => {
                if (transitionTO) {clearTimeout(transitionTO); transitionTO = void 0;}
                window.dispatchEvent(new Event('refresh'));

                setShowUI(true);

                coverContainer.style.transitionDuration = '500ms';
                coverContainer.style.opacity = '1';


                if (curSection === 3) {
                    footerEl.classList.remove('inactive');
                    footerEl.classList.add('active');
                } else {
                    footerEl.classList.remove('active');
                }

                prepareNewSlide(curSection);

                transitionTO = setTimeout(() => {
                    if (transitionTO) {clearTimeout(transitionTO); transitionTO = void 0;}
                    // Move top at once:
                    coverContainer.deltaY = 0;
                    coverContainer.style.transform = 'translate3d(0, 0, 0)';
                    window.scrollTo(0, 0);
                    setNewSlide(prevIndex, curSection);

                }, 1500 + 50);

            }, 100);
        }



    });

    function prepareNewSlide(realIndex) {
        switch (realIndex) {
            case 0:
                break;
            case 1:
                sectionWeek.classList.remove('inactive');
                break;
            case 2:

                break;
            case 3:
                sectionNews.classList.remove('inactive');
                break;
        }

    }

    function setNewSlide(prevIndex, realIndex) {


        switch (realIndex) {
            case 0:
                break;
            case 1:
                sectionWeek.classList.add('active');
                break;
            case 2:

                break;
            case 3:
                sectionNews.classList.add('active');
                break;
        }


        if (curSection !== 3) {
            footerEl.classList.add('inactive');
        }


        switch (prevIndex) {
            case 0:

                break;
            case 1:
                sectionWeek.classList.add('inactive');
                break;
            case 2:

                break;
            case 3:
                sectionNews.classList.add('inactive');
                break;
        }

         transitionTO = setTimeout(() => {
            setShowUI(true);
            if (transitionTO) {clearTimeout(transitionTO); transitionTO = void 0;}
            window.dispatchEvent(new Event('refresh'));
        }, 100);

    }

    function resetPrevSlide(prevSlide) {
        switch (prevSlide) {
            case 0:

                break;
            case 1:
                sectionWeek.classList.remove('active');
                sectionWeek.classList.add('inactive');
                break;
            case 2:

                break;
            case 3:
                sectionNews.classList.remove('active');
                sectionNews.classList.add('inactive');
                break;
        }
    }

    footerEl.classList.add('inactive');
    updateBody();
    updateMenu();

}

const Mousewheel = require('./js/utils/Mousewheel');
let mousewheelEnabled = false;
let touchEnabled = false;
let mousewheelNextEnabled = false;
let mousewheelPrevEnabled = false;
let lastScrollTime = (new window.Date()).getTime();
const touches = {
    touchStartTime: -1
};
function switchOnWinScrollStateUpdate() {
    const update = () => {

        let rect = coverContainer.getBoundingClientRect();
        // console.log(rect.top, rect.top >= 0);
        const newMousewheelPrevEnabled = rect.top >= 0;

        rect = scrlNextTrgrEl.getBoundingClientRect();
        // console.log(scrlNextTrgrEl, rect.bottom, SizesUtils.winOffsetHeight(), rect.bottom - SizesUtils.winOffsetHeight(), rect.bottom - SizesUtils.winOffsetHeight() <= 0);
        const newMousewheelNextEnabled = rect.bottom - SizesUtils.winOffsetHeight() <= 0;

        if (newMousewheelPrevEnabled !== mousewheelPrevEnabled || newMousewheelNextEnabled !== mousewheelNextEnabled)
            lastScrollTime = (new window.Date()).getTime();

        mousewheelPrevEnabled = newMousewheelPrevEnabled;
        mousewheelNextEnabled = newMousewheelNextEnabled;
    };


    scrlNextTrgrEl.style.transform = 'translate3d(0, -2px, 0)';

    update();

    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('refresh', update);
}
function switchOnWinScroll(txSw) {
    const swiper = txSw;

    if (Mousewheel.event && !mousewheelEnabled) {

        document.addEventListener(Mousewheel.event, e => {

            if (e.originalEvent) { e = e.originalEvent; }
            const data = Mousewheel.normalize(e);
            let delta = 0;
            if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = -data.pixelY; }
            if (delta === 0) { return true; }

            const now = (new window.Date()).getTime();
            if (now - lastScrollTime > 600) {
                if (delta < 0) {
                    if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                        if (!mousewheelNextEnabled) return true;
                        swiper.slideNext();
                        swiper.emit('scroll', e);
                    } else if (swiper.params.releaseOnEdges) { return true; }
                } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
                    if (!mousewheelPrevEnabled) return true;
                    swiper.slidePrev();
                    swiper.emit('scroll', e);
                } else if (swiper.params.releaseOnEdges) { return true; }

                e.preventDefault();
            }
            lastScrollTime = now;

        });
        mousewheelEnabled = true;

    }

    if (!touchEnabled) {
        const onTouchStart = evt => {
            let e = evt;
            if (e.originalEvent) { e = e.originalEvent; }
            touches.isTouched = true;
            touches.currentX = touches.startX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            touches.currentY = touches.startY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            touches.touchStartTime = (new window.Date()).getTime();
        }
        const onTouchMove = evt => {
            if (!touches.isTouched) return;

            let e = evt;
            if (e.originalEvent) { e = e.originalEvent; }
            // let pageX = touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            const pageY = touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;


            if (
                pageY < touches.startY && pageY < 1 ||
                pageY > touches.startY && pageY > 10000
            ) {
                touches.isTouched = false;
                const delta = touches.currentY - touches.startY;

                if (Math.abs(delta) > 0.3 * SizesUtils.winOffsetHeight()) {
                    if (delta < 0) {
                        if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                            if (!mousewheelNextEnabled) return true;
                            swiper.slideNext();
                            swiper.emit('scroll', e);
                        } else if (swiper.params.releaseOnEdges) { return true; }
                    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
                        if (!mousewheelPrevEnabled) return true;
                        swiper.slidePrev();
                        swiper.emit('scroll', e);
                    } else if (swiper.params.releaseOnEdges) { return true; }
                }
            }
        }
        const onTouchEnd = evt => {
            if (!touches.isTouched) return;

            let e = evt;
            if (e.originalEvent) { e = e.originalEvent; }


            touches.isTouched = false;
            const delta = touches.currentY - touches.startY;

            if (Math.abs(delta) > 0.3 * SizesUtils.winOffsetHeight()) {
                if (delta < 0) {
                    if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                        if (!mousewheelNextEnabled) return true;
                        swiper.slideNext();
                        swiper.emit('scroll', e);
                    } else if (swiper.params.releaseOnEdges) { return true; }
                } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
                    if (!mousewheelPrevEnabled) return true;
                    swiper.slidePrev();
                    swiper.emit('scroll', e);
                } else if (swiper.params.releaseOnEdges) { return true; }

                // e.preventDefault();
            }
        }


        {
            if (!txSw.support.touch && (txSw.support.pointerEvents || txSw.support.prefixedPointerEvents)) {
                document.addEventListener(txSw.touchEvents.start, onTouchStart, false);
                document.addEventListener(txSw.touchEvents.move, onTouchMove, false);
                document.addEventListener(txSw.touchEvents.end, onTouchEnd, false);
            } else {
                if (txSw.support.touch) {
                    const passiveListener = txSw.touchEvents.start === 'touchstart' && txSw.support.passiveListener && txSw.params.passiveListeners ? {passive: true, capture: false} : false;
                    document.addEventListener(txSw.touchEvents.start, onTouchStart, passiveListener);
                    document.addEventListener(txSw.touchEvents.move, onTouchMove, false);
                    document.addEventListener(txSw.touchEvents.end, onTouchEnd, passiveListener);
                }
                if (txSw.params.simulateTouch && !txSw.device.ios && !txSw.device.android || txSw.params.simulateTouch && !txSw.support.touch && txSw.device.ios) {
                    document.addEventListener('mousedown', onTouchStart, false);
                    document.addEventListener('mousemove', onTouchMove, false);
                    document.addEventListener('mouseup', onTouchEnd, false);
                }
            }
        }
        touchEnabled = true;
    }


}



function updateBody() {
    document.body.dataset.section = curSection;
}

function updateMenu() {
    menuD.close();
    menuD.setCurrent(curSection);
    menuM.close();
    menuM.setCurrent(curSection);
    menuF.setCurrent(curSection);
}


function initMenu() {
    menuD.on('request', evt => {
        txSw.slideTo(evt.section);
    });
    menuM.on('request', evt => {
        txSw.slideTo(evt.section);
    });
    menuF.on('request', evt => {
        txSw.slideTo(evt.section);
    });
}

/*  ANIMATION  */

const animationSrc = require('./js/animation/MBFWR_Covers_Anim');

function loadImages(manifest, images, lib, ss, preloader) {
    const handleProgress = evt => {
        if(!preloader) return;
        preloader.setProgress(evt.progress * 0.95);
    }

    const handleFileLoad = evt => {
        if (evt && evt.item.type === 'image')  images[evt.item.id] = evt.result;
    }

    const createSpriteSheets = (queue, lib, ss) => {
        const ssMetadata = lib.ssMetadata;
        let i;
        for(i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({images: [queue.getResult(ssMetadata[i].name)], frames: ssMetadata[i].frames});
        }
    }

    const handleComplete = (evt, resolve) => {
        // console.log(evt, success)

        createSpriteSheets(evt.target, lib, ss);

        resolve();
    }

    return new Promise(function (resolve) {
        const loader = new createjs.LoadQueue(false);
        loader.addEventListener('progress', function (evt) {handleProgress(evt)});
        loader.addEventListener('fileload', function (evt) {handleFileLoad(evt, images)});
        loader.addEventListener('complete', function (evt) {handleComplete(evt, resolve)});
        loader.loadManifest(manifest);
    })
}

const TouchSupport = require('./js/utils/TouctSupport');

const startLoadingTime = (new window.Date()).getTime();
const preloader = require('./js/preloader');
const minPreloadDuration = 2;
loadImages(animationSrc.library.properties.manifest, animationSrc.images, animationSrc.library, animationSrc.spriteSheet, preloader).then(
    () => {
        week.init();
        return new Promise(function (resolve) {
            const dt = (new window.Date()).getTime() - startLoadingTime - minPreloadDuration * 1000;
            if (dt >= 0) {
                resolve();
                return;
            }

            setTimeout(resolve, -dt)
        });
    }
).then(
    () => {
        setLoaded(true);
        setLoading(false);
        preloader.setProgress(1);

        return new Promise(function (resolve) {


            const btn = document.querySelector('#startAll');
            const touches = {};
            const onMouseWheel = e => {

                if (e.originalEvent) { e = e.originalEvent; }
                const data = Mousewheel.normalize(e);
                let delta = 0;
                if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = -data.pixelY; }
                if (delta === 0) { return true; }

                done();

            };

            const onTouchStart = evt => {
                let e = evt;
                if (e.originalEvent) { e = e.originalEvent; }
                touches.isTouched = true;
                touches.currentX = touches.startX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                touches.currentY = touches.startY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
                touches.touchStartTime = (new window.Date()).getTime();
            }
            const onTouchMove = evt => {
                if (!touches.isTouched) return;

                let e = evt;
                if (e.originalEvent) { e = e.originalEvent; }
                const pageX = touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                const pageY = touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;


                if (
                    pageX < touches.startY && pageX < 1 ||
                    pageX > touches.startY && pageX > 10000 ||
                    pageY < touches.startY && pageY < 1 ||
                    pageY > touches.startY && pageY > 10000
                ) {
                    touches.isTouched = false;
                    const deltaY = touches.currentY - touches.startY;
                    const deltaX = touches.currentX - touches.startX;

                    if (Math.abs(deltaX) > 0.3 * SizesUtils.winOffsetWidth()) {
                        if (deltaX < 0) {
                            done();
                        }
                        // e.preventDefault();
                    }

                    if (Math.abs(deltaY) > 0.3 * SizesUtils.winOffsetHeight()) {
                        if (deltaY < 0) {
                            done();
                        }
                        // e.preventDefault();
                    }
                }
            }
            const onTouchEnd = evt => {
                if (!touches.isTouched) return;

                let e = evt;
                if (e.originalEvent) { e = e.originalEvent; }


                touches.isTouched = false;
                const deltaY = touches.currentY - touches.startY;
                const deltaX = touches.currentX - touches.startX;

                if (Math.abs(deltaX) > 0.3 * SizesUtils.winOffsetWidth()) {
                    if (deltaX < 0) {
                        done();
                    }
                    // e.preventDefault();
                }

                if (Math.abs(deltaY) > 0.3 * SizesUtils.winOffsetHeight()) {
                    if (deltaY < 0) {
                        done();
                    }
                    // e.preventDefault();
                }

            }

            const onStartAll = () => {
                done();
            }

            const done = () => {

                if (btn) {
                    btn.removeEventListener('click', onStartAll);
                }

                if (Mousewheel.event) {

                    document.removeEventListener(Mousewheel.event, onMouseWheel);
                }

                {
                    if (!TouchSupport.touch && (TouchSupport.support.pointerEvents || TouchSupport.support.prefixedPointerEvents)) {
                        document.removeEventListener(TouchSupport.touchEvents.start, onTouchStart, false);
                        document.removeEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                        document.removeEventListener(TouchSupport.touchEvents.end, onTouchEnd, false);
                    } else {
                        if (TouchSupport.support.touch) {
                            const passiveListener = false;
                            document.removeEventListener(TouchSupport.touchEvents.start, onTouchStart, passiveListener);
                            document.removeEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                            document.removeEventListener(TouchSupport.touchEvents.end, onTouchEnd, passiveListener);
                        }
                        if (!TouchSupport.device.ios && !TouchSupport.device.android || !TouchSupport.support.touch && TouchSupport.device.ios) {
                            document.removeEventListener('mousedown', onTouchStart, false);
                            document.removeEventListener('mousemove', onTouchMove, false);
                            document.removeEventListener('mouseup', onTouchEnd, false);
                        }
                    }
                }

                resolve();
            }

            if (btn) {
                btn.addEventListener('click', onStartAll);
            }

            if (Mousewheel.event) {

                document.addEventListener(Mousewheel.event, onMouseWheel);
            }

            {
                if (!TouchSupport.touch && (TouchSupport.support.pointerEvents || TouchSupport.support.prefixedPointerEvents)) {
                    document.addEventListener(TouchSupport.touchEvents.start, onTouchStart, false);
                    document.addEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                    document.addEventListener(TouchSupport.touchEvents.end, onTouchEnd, false);
                } else {
                    if (TouchSupport.support.touch) {
                        const passiveListener = false;
                        document.addEventListener(TouchSupport.touchEvents.start, onTouchStart, passiveListener);
                        document.addEventListener(TouchSupport.touchEvents.move, onTouchMove, false);
                        document.addEventListener(TouchSupport.touchEvents.end, onTouchEnd, passiveListener);
                    }
                    if (!TouchSupport.device.ios && !TouchSupport.device.android || !TouchSupport.support.touch && TouchSupport.device.ios) {
                        document.addEventListener('mousedown', onTouchStart, false);
                        document.addEventListener('mousemove', onTouchMove, false);
                        document.addEventListener('mouseup', onTouchEnd, false);
                    }
                }
            }




        });
    }
). then (
    () => {
        initSW ();
        initMenu ();

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            setTimeout(() => {
                setStarted(true);
                setTimeout(() => {
                    preloader.clear();
                }, 1700);
            }, 100);
        }, 100);
    }
);





// WEBPACK FOOTER //
// ./app.js